var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_308_296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.682 36.046V37.7939C14.682 38.4825 14.8382 39.1643 15.1418 39.8005C15.4454 40.4366 15.8904 41.0146 16.4513 41.5015C17.0124 41.9885 17.6783 42.3748 18.4111 42.6382C19.144 42.9017 19.9296 43.0374 20.7229 43.0374C21.5163 43.0374 22.3019 42.9017 23.0348 42.6382C23.7676 42.3748 24.4335 41.9885 24.9945 41.5015C25.5555 41.0146 26.0005 40.4366 26.304 39.8005C26.6077 39.1643 26.7639 38.4825 26.7639 37.7939V36.046",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8324 36.0457C36.8324 36.0457 32.8051 27.3066 32.8051 22.0631C32.8051 16.3511 27.3038 11.576 20.7231 11.576C14.1425 11.576 8.6412 16.3511 8.6412 22.0631C8.6412 29.0544 4.61389 36.0457 4.61389 36.0457H36.8324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.1785,
    cy: 9.91675,
    r: 9,
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5591 9.50133C33.8466 9.14507 33.4903 8.58328 33.4903 7.81595C33.4903 7.44599 33.5828 7.10686 33.7678 6.79856C33.9528 6.49026 34.2302 6.24705 34.6002 6.06892C34.9702 5.88394 35.4223 5.79145 35.9567 5.79145C36.4843 5.79145 36.933 5.88394 37.303 6.06892C37.6798 6.24705 37.9607 6.49026 38.1457 6.79856C38.3306 7.10686 38.4231 7.44599 38.4231 7.81595C38.4231 8.19962 38.3238 8.53875 38.1251 8.83335C37.9333 9.12109 37.6764 9.34375 37.3544 9.50133C37.7449 9.6452 38.0532 9.88157 38.2793 10.2104C38.5053 10.5324 38.6184 10.9127 38.6184 11.3511C38.6184 11.7965 38.5053 12.1904 38.2793 12.533C38.0532 12.8755 37.738 13.1393 37.3338 13.3243C36.9296 13.5092 36.4706 13.6017 35.9567 13.6017C35.4429 13.6017 34.9839 13.5092 34.5797 13.3243C34.1823 13.1393 33.8706 12.8755 33.6445 12.533C33.4184 12.1904 33.3053 11.7965 33.3053 11.3511C33.3053 10.9058 33.4184 10.5221 33.6445 10.2001C33.8706 9.87814 34.1754 9.6452 34.5591 9.50133ZM37.303 7.95983C37.303 7.57616 37.1831 7.28157 36.9433 7.07603C36.7035 6.8705 36.3746 6.76773 35.9567 6.76773C35.5457 6.76773 35.2202 6.8705 34.9804 7.07603C34.7407 7.28157 34.6208 7.57959 34.6208 7.9701C34.6208 8.31266 34.7441 8.59356 34.9907 8.81279C35.2442 9.02518 35.5662 9.13137 35.9567 9.13137C36.3472 9.13137 36.6692 9.02175 36.9227 8.80252C37.1762 8.58328 37.303 8.30238 37.303 7.95983ZM35.9567 10.0152C35.5046 10.0152 35.1346 10.1282 34.8468 10.3543C34.566 10.5735 34.4255 10.8921 34.4255 11.31C34.4255 11.7005 34.5625 12.0191 34.8366 12.2658C35.1106 12.5055 35.484 12.6254 35.9567 12.6254C36.4226 12.6254 36.7891 12.5021 37.0563 12.2555C37.3304 12.0088 37.4674 11.6937 37.4674 11.31C37.4674 10.899 37.327 10.5804 37.0461 10.3543C36.772 10.1282 36.4089 10.0152 35.9567 10.0152Z",
    fill: "#0A0101"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_308_296",
    x: 0.613892,
    y: 0.916748,
    width: 48.5646,
    height: 50.1206,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_308_296"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_308_296",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.c1a4135c1e4703cd4420681848ae7af7.svg";
export { ForwardRef as ReactComponent };